// Module
var code = "<div class=\"top\" ng-click=\"toggleMenu()\" >\n    <i class=\"custom-icon\" ng-class=\"[icon]\"></i>\n</div>\n<div class=\"options\"  ng-transclude>\n\n</div>\n";
// Exports
module.exports = code;